//////////////////////////////////////////////////////////////////////
///     Este componente foi modificado do original do tema.        ///
///     É basicamente igual só removendo/alterando algumas partes. ///
///     Checar novas versões manualmente.                          ///
//////////////////////////////////////////////////////////////////////

import Button from "components/CustomButtons/Button.jsx";
import classNames from "classnames";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Paper from "@material-ui/core/Paper";
import SettingsRounded from "@material-ui/icons/SettingsRounded";
import Popper from "@material-ui/core/Popper";
import PropTypes from "prop-types";
import React, { Component } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";

import headerLinksStyle from "assets/jss/material-dashboard-pro-react/components/headerLinksStyle";
import { logout } from "reducers/user/actions";

class HeaderLinks extends Component {
  state = {
    open: false,
  };

  handleClick = () => {
    this.setState({ open: !this.state.open });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  logout = () => {
    this.props.logout()
      .then(() => window.location.href = "/")
      .catch(() => window.location.href = "/");
  }

  render() {
    const { classes } = this.props;
    const { open } = this.state;
    const dropdownItem = classes.dropdownItem;

    return (
      <div>
        <Button
          aria-haspopup="true"
          aria-label="Notifications"
          aria-owns={open ? "menu-list" : null}
          buttonRef={node => {
            this.anchorEl = node;
          }}
          className={classes.buttonLink}
          color="transparent"
          justIcon
          onClick={this.handleClick}
        >
          <SettingsRounded className={classes.links} />
          {/* TODO: Ajustar esse botão estranho no hover. Provalmente retirar essa opção e jogar na lista embaixo de Meu Perfil. */}
          {/* <Hidden mdUp>
            <p className={classes.linkText} onClick={this.handleClick}>
              {"Opç˜ões"}
            </p>
          </Hidden> */}
        </Button>
        <Popper
          anchorEl={this.anchorEl}
          className={classNames({
            [classes.popperClose]: !open,
            [classes.pooperResponsive]: true,
            [classes.pooperNav]: true,
          })}
          disablePortal
          open={open}
          placement="bottom"
          transition
        >
          <ClickAwayListener onClickAway={this.handleClose}>
            <Grow
              id="menu-list"
              in={open}
              style={{ transformOrigin: "0 0 0" }}
            >
              <Paper className={classes.dropdown}>
                <MenuList role="menu">
                  <MenuItem className={dropdownItem} onClick={this.logout}>
                    Sair
                  </MenuItem>
                </MenuList>
              </Paper>
            </Grow>
          </ClickAwayListener>
        </Popper>
      </div>
    );
  }
}

HeaderLinks.propTypes = {
  classes: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  logout,
};

export default connect(null, mapDispatchToProps)(withStyles(headerLinksStyle)(HeaderLinks));



// WEBPACK FOOTER //
// ./src/components/EnergyCompany/Header/HeaderLinks.jsx